import { jsx as s } from "react/jsx-runtime";
import { useRef as d, useEffect as f, useMemo as p } from "react";
import { ThemeColor as a } from "../../../types.js";
import { isDark as u, updateBodyClass as T, updateMetaThemeColor as C } from "../../../utils/theme.js";
import { Theme as t, ThemeContext as v } from "../ThemeContext.js";
import y from "./ThemeProvider.module.css.js";
const j = (i) => {
  const { children: n, systemTheme: h = t.light, onThemeChange: r, theme: e = t.auto } = i, o = e === t.auto ? h : e, m = u(o) ? a.dark : a.light, l = d(null);
  f(() => {
    T(o), C(e, m, l);
  }, [o, m, e]);
  const c = p(
    () => ({
      theme: e,
      onThemeChange: r
    }),
    [e, r]
  );
  return /* @__PURE__ */ s(v.Provider, { value: c, children: /* @__PURE__ */ s("div", { className: y.themeContainer, "data-test": "theme-container", children: n }) });
};
export {
  j as ThemeProvider
};
